module.exports = __webpack_public_path__ + "static/media/rbtc.eb5e5cf9.svg";